// builder-components.ts
import { Builder } from '@builder.io/react';

import CallCampaignButton from './call-campaign-button-tty-icon';

Builder.registerComponent(CallCampaignButton, {
  name: 'CallCampaignButtonTtyIcon',
  noWrap: true,
});
